import { BrowserModule, Title } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  NbThemeModule,
  NbMenuModule,
  NbSidebarModule,
  NbDialogModule,
  NbToastrModule,
  NbSpinnerModule,
} from '@nebular/theme';
import { AppComponent } from './app.component';

import { HttpClientModule } from '@angular/common/http';
import { GlobalErrorHandler } from './error-handler';
import { NbAuthModule, NbPasswordAuthStrategy } from '@nebular/auth';
import { AuthGuard } from './auth-guard.service';
import { PasswordGuard } from './password-guard';
import { DirectivesModule } from './directives/directives.module';
import { TimeagoModule } from 'ngx-timeago';
import { ErrorInterceptor } from './http-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { PageAccessGuard } from './page-access-auth.guard';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CanDeactivateGuard } from './can-deactivate.guard';
import { LoginRedirectGuard } from './login-redirect.guard';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './custom-route-reuse.strategy';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const localDevMode = () => {
  return window.location.hostname === 'localhost';
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
        }),
      ],
    }),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NbThemeModule.forRoot({ name: 'facets' }),
    HttpClientModule,
    NbMenuModule.forRoot(),
    DirectivesModule,
    NbSpinnerModule,
    FormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    // PaaSSaaSSwitchModule,
    NbSidebarModule.forRoot(),
    NbDialogModule.forRoot(),
    TimeagoModule.forRoot(),
    NbToastrModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
      enabled: !localDevMode(),
    }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    { provide: APP_BASE_HREF, useValue: '/capc' },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AuthGuard,
    PasswordGuard,
    PageAccessGuard,
    CanDeactivateGuard,
    LoginRedirectGuard,
    // {
    //   provide: MONACO_PATH,
    //   useValue: '/assets/monaco/vs',
    // },
    Title,
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
